import { useState } from 'react';
// mantine
import { Switch } from '@mantine/core';
// components
import { BillingPlansDetails } from '@newo/ui-kit';
// utils
import { BILLING_SUBSCRIPTIONS } from '@newo/constants';
import SubscriptionCard from '@/pages/Profile/components/Billing/components/SubscriptionCard';
import { useBillingCheckoutUrlMutation } from '@/services/customer/profile/profile.queries.ts';

interface PlansProps {
    idn: string;
    activePlan?: string;
    withTrial: boolean;
    isDeveloperMode: boolean;
}

const Plans = ({ idn, activePlan, withTrial, isDeveloperMode }: PlansProps) => {
    const [isAnnual, setIsAnnual] = useState(!activePlan?.includes('monthly'));

    const { mutateAsync: getCheckoutUrl } = useBillingCheckoutUrlMutation();

    const plans = isAnnual
        ? BILLING_SUBSCRIPTIONS.annual
        : BILLING_SUBSCRIPTIONS.monthly;

    const handleSubscription = async (productKey: string) => {
        try {
            const response = await getCheckoutUrl({
                customer_idn: idn,
                product_key: productKey,
                success_url: globalThis.location.href,
                trial_enabled: true
            });
            globalThis.location.href = response.url;
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="flex flex-col gap-8">
            <div className="flex flex-col md:flex-row md:justify-between items-start gap-4">
                <div className="text-xl font-bold leading-tight">
                    Subscription Plans
                </div>

                <div className="flex md:justify-center text-sm gap-2 items-center">
                    Monthly
                    <Switch
                        checked={isAnnual}
                        size="md"
                        onChange={(event) => {
                            setIsAnnual(event.currentTarget.checked);
                        }}
                    />
                    Annual
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5">
                {plans.map((plan) => {
                    const isActive = activePlan === plan.id;
                    return (
                        <SubscriptionCard
                            id={plan.id}
                            isActive={isActive}
                            isDisabled={isDeveloperMode || isActive}
                            key={plan.id}
                            phoneSessions={plan.phoneSessions}
                            price={plan.price}
                            textSessions={plan.textSessions}
                            title={plan.title}
                            withTrial={withTrial}
                            onSubscribe={handleSubscription}
                        />
                    );
                })}
            </div>
            <BillingPlansDetails />
        </div>
    );
};

export default Plans;
